import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import classNames from 'classnames'
import { ReactNode } from 'react'
import { Icon, IconName, Text } from '../../atoms'

export interface AccordionCardProps {
  title: string
  icon?: IconName
  defaultOpen?: boolean
  className?: string
  children: ReactNode
}

export const AccordionCard = ({ title, icon, defaultOpen, className, children }: AccordionCardProps) => (
  <Disclosure
    as="section"
    defaultOpen={defaultOpen}
    className={classNames('grid grid-cols-[auto_1fr_auto] gap-x-2 bg-white rounded-lg drop-shadow-02 p-4', className)}
  >
    {({ open }) => (
      <>
        <Text as="h3" textType="lg" className="col-span-3 grid grid-cols-subgrid m-0">
          <DisclosureButton className="col-span-3 grid grid-cols-subgrid items-center text-left cursor-pointer">
            {icon ? <Icon icon={icon} className="text-emphasis-extra" /> : <span />}
            {title}
            <Icon icon={open ? 'chevron-up' : 'chevron-down'} className="text-emphasis-high" />
          </DisclosureButton>
        </Text>
        <DisclosurePanel className="col-span-3 grid grid-cols-subgrid">
          <hr className="col-span-3 my-4 border-0 border-t border-gray-300" />
          <div className="col-start-2 col-span-2">{children}</div>
        </DisclosurePanel>
      </>
    )}
  </Disclosure>
)
